import { Dispatch, SetStateAction } from 'react';
import { StyledPopoverButton } from 'components/new-ui/composed/popover-buttons-group/styles';
import PopoverButtonsGroup from 'components/new-ui/composed/popover-buttons-group/PopoverButtonsGroup';

type Props = {
    open: boolean;
    disabled?: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
    onNewTeamMemberClick?: () => void;
    onNewManifestClick?: () => void;
    onNewJobClick?: () => void;
    onNewCustomerClick?: () => void;
};

const NewTeamActionsPopover = ({
    open,
    disabled,
    setOpen,
    onNewTeamMemberClick,
    onNewManifestClick,
    onNewJobClick,
    onNewCustomerClick,
}: Props) => {
    return (
        <>
            <PopoverButtonsGroup disabled={disabled} open={open} onOpenChange={(next) => setOpen(next)}>
                {onNewManifestClick && (
                    <StyledPopoverButton
                        style={{ textAlign: 'left' }}
                        onClick={() => {
                            setOpen(false);
                            onNewManifestClick?.();
                        }}
                    >
                        Manifest
                    </StyledPopoverButton>
                )}

                {onNewJobClick && (
                    <StyledPopoverButton
                        style={{ textAlign: 'left' }}
                        onClick={() => {
                            setOpen(false);
                            onNewJobClick?.();
                        }}
                    >
                        Job
                    </StyledPopoverButton>
                )}

                {onNewCustomerClick && (
                    <StyledPopoverButton
                        style={{ textAlign: 'left' }}
                        onClick={() => {
                            setOpen(false);
                            onNewCustomerClick?.();
                        }}
                    >
                        Customer
                    </StyledPopoverButton>
                )}

                {onNewTeamMemberClick && (
                    <StyledPopoverButton
                        style={{ textAlign: 'left' }}
                        onClick={() => {
                            setOpen(false);
                            onNewTeamMemberClick?.();
                        }}
                    >
                        Team Member
                    </StyledPopoverButton>
                )}
            </PopoverButtonsGroup>
        </>
    );
};

export default NewTeamActionsPopover;
